import React from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar } from 'react-chartjs-2';
import { getColorByGroup, getColorByGroup2, getColorByGroup3 } from '../calculations/calcV2';

interface BarGraphSimpleProps {
  title: string,
  labels: string[],
  dataNow: number[],
  dataBefore?: number[],
  election?: number[],
  bgColor?: string,
  groups: string[],
}

export const BarGraphSimple = (props: BarGraphSimpleProps) => {
    const { title, labels, dataNow, dataBefore, election, bgColor, groups } = props;
    const background = bgColor ?? '#333';

    const plugin = {
        id: 'background',
        beforeDraw: (chart, args, opts) => {
          if (!opts.color) {
            return;
          }
      
          const {
            ctx,
            chartArea
          } = chart;
      
          ctx.fillStyle = opts.color;
          ctx.fillRect(chartArea.left, chartArea.top, chartArea.width, chartArea.height)
        }
      }

    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend,
        plugin,
        ChartDataLabels
      );
      
      const options: any = {
        plugins: {
          title: {
            display: true,
            text: title,
          },
          legend: { 
            display: false
          },
          background: { color: background },

          datalabels: {
            display: true,
            color: "#fff",
            formatter: Math.round,
            anchor: "end",
            offset: 2,
            align: "start",
          }
        },
        responsive: true,
        interaction: {
          mode: 'index',
          intersect: false,
        },
        scales: {
          x: {
            stacked: false,
          },
          y: {
            stacked: false,
          },
        },
        datasets: {
            bar: {
                barPercentage: 1.4,
                categoryPercentage: 0.60
            }
        },
        animation: {},
      };
      if (background !== '#333'){ options.animation = { duration: 0 }; }
      
      const datasets = dataBefore === undefined ?
      [{
        data: dataNow,
        backgroundColor: groups.map(x => getColorByGroup(x)),
        stack: '1',
      }]
      : (dataBefore?.reduce((a, b) => a + b, 0) === 0
        ? [
            {
              data: dataNow,
              backgroundColor: groups.map(x => getColorByGroup(x)),
              stack: '1',
            },
            {
              data: election,
              backgroundColor: groups.map(x => getColorByGroup3(x)),
              stack: '3',
              datalabels: { color: '#555' }
            },
          ]
        : [
        {
          data: dataNow,
          backgroundColor: groups.map(x => getColorByGroup(x)),
          stack: '1',
        },
        {
          data: dataBefore,
          backgroundColor: groups.map(x => getColorByGroup2(x)),
          stack: '2',
        },
        {
          data: election,
          backgroundColor: groups.map(x => getColorByGroup3(x)),
          stack: '3',
          datalabels: { color: '#555' }
        },
      ]);
      const data = {
        labels,
        datasets: datasets,
      };

    return (
        <div style={{backgroundColor: background}}>
            <Bar options={options} data={data} />
        </div>
    )
}
